import React, { useState, useEffect } from "react";
import { Box, Typography, Switch, Tooltip, IconButton } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import { toast } from "react-toastify";

export default function AllowReject({ apiSetting, updateApiSetting }) {

  const labelWidth = 200;
  const [dataList, setDataList] = useState({});
  const [isChecked, setIsChecked] = useState(false);

  useEffect(() => {
    setIsChecked(apiSetting?.twoFA);
  }, [apiSetting]);

  const handleChange = (event) => {
    //check SMTP credential
    if((!apiSetting.smtp_email) || !apiSetting.smtp_host || !apiSetting.smtp_pass ||!apiSetting.smtp_port){
      toast.error(`Please fill up SMTP credential first.`, {
        position: "top-right",
        stopOnFocus: true,
      });
    } else {
      const checked = event.target.checked; 
      setIsChecked(checked);
      const updatedDataList = { ...apiSetting, twoFA: checked }; 
      setDataList(updatedDataList); 
      updateApiSetting(updatedDataList); 
    }
  };

  return (
    <Box p={3}>
      <Box display="flex" mb={2} sx={{ marginTop: "-24px" }}>
        <Typography
          display="flex"
          alignItems="center"
          pr={4}
          sx={{ minWidth: labelWidth, paddingRight: "-32px" }}
        >
          Two Factor Authentication (2FA)
        </Typography>
        <IconButton color="primary">
          <Tooltip title="When logging into your account, in addition to your username and password, you'll enter a unique login code sent to your email." placement="right">
            <InfoIcon />
          </Tooltip>
        </IconButton>
        <Box display="flex" justifyContent="end">
          <Switch
            checked={isChecked}
            id="switch"
            onChange={handleChange}
          />
        </Box>
      </Box>
    </Box>
  );
}
